import { Check } from "lucide-react";

interface StepSuccessProps {
  title: string;
  description: string;
}

export function StepSuccess({ title, description }: StepSuccessProps) {
  return (
    <div className="flex flex-col items-center py-6 text-center">
      <div className="flex size-11 items-center justify-center rounded-full bg-emerald-50 text-emerald-600 ring-1 ring-emerald-600/15 ring-inset">
        <Check aria-hidden="true" className="size-5" />
      </div>
      <p className="mt-4 text-lg font-semibold tracking-[-0.01em]">{title}</p>
      <p className="mt-1 text-sm text-muted-foreground">{description}</p>
    </div>
  );
}
